export default {
  container: {
    padding: '0 0 30px'
  },
  content: {
    '& > div': {
      marginTop: '30px',
      '&:first-child': {
        marginTop: '0'
      }
    }
  }
}
